const showDeliveryCostsNotice = (
    deliveryCostsNoticeIsDisabled,
    deliveryCostsNoticeLinkDescription,
    deliveryCostsNoticeIsThreshold,
    commerceMarket,
    priceHasResolved,
    unitPrice,
    quantity,
    basketPriceView
) => {
    if (deliveryCostsNoticeIsDisabled) {
        return false;
    }
    if (!deliveryCostsNoticeLinkDescription) {
        return false;
    }
    if (!priceHasResolved) {
        return false;
    }
    if (!unitPrice || !quantity) {
        return false;
    }
    if (!deliveryCostsNoticeIsThreshold || !commerceMarket) {
        return false;
    }

    let thresholdForMarket = JSON.parse(deliveryCostsNoticeIsThreshold)[commerceMarket.toLowerCase()];
    if (!thresholdForMarket) {
        return false;
    }

    let basketTotal = basketPriceView ? basketPriceView.subTotal : 0;
    if (basketTotal >= thresholdForMarket) {
        return false;
    }
    if ((unitPrice * quantity) + basketTotal >= thresholdForMarket) {
        return false;
    }

    return true;
}

export default showDeliveryCostsNotice;